<template>
  <a-dropdown :trigger="['contextmenu']">
    <div class="search-form-container" @keyup.enter="handleSubmit">
      <a-form class="search-form-wrapper" v-show="isExtend" :form="form">
        <template v-for="item in formList">
          <a-form-item :label="item.label" :key="item.key" class="form-item-wrapper">
            <template v-if="item.type === 'select'">
              <a-select
                :size="size"
                showSearch
                placeholder="请选择"
                v-decorator="[item.key]"
                :allowClear="true"
                style="width: 100%"
                optionFilterProp="children"
                @change="
                  item.handlSelectChange
                    ? item.handlSelectChange($event, item.value)
                    : handleSelectChange($event, item.value)
                "
              >
                <template v-for="optionItem in item.selectData">
                  <a-select-option :value="optionItem.value" :key="optionItem.value">
                    {{ optionItem.label }}
                  </a-select-option>
                </template>
              </a-select>
            </template>
            <template v-if="item.type === 'input'">
              <a-input
                :size="size"
                :allowClear="true"
                placeholder="请输入"
                @pressEnter="handleSubmit"
                v-decorator="[item.key]"
              />
            </template>
            <template v-if="item.type === 'RangePicker'">
              <a-range-picker
                :size="size"
                style="width: 320px"
                v-decorator="[item.key, item.config || {}]"
                :show-time="item.isShowTime"
                :format="item.format || 'YYYY-MM-DD'"
                :disabled-date="disabledDate"
              />
            </template>
            <template v-if="item.type === 'picker'">
              <a-date-picker :size="size" v-decorator="[item.key]" format="YYYY-MM-DD" />
            </template>
          </a-form-item>
        </template>
        <div :class="['button-list-wrapper']">
          <a-button
            class="btn-warapper"
            style="height: 26px; font-weight: bold"
            @click="handleSetExtendToggle"
          >
            {{ isExtend ? '收缩' : '展开' }}
          </a-button>
          <a-button
            class="btn-warapper"
            type="primary"
            @click="handleSubmit"
            style="height: 26px; background: red; border: none"
          >
            查询
          </a-button>
          <a-button
            class="btn-warapper"
            @click="handleReset"
            style="height: 26px; font-weight: bold"
          >
            重置
          </a-button>
        </div>
      </a-form>
    </div>
    <a-menu slot="overlay" @click="rightMenuClick">
      <a-menu-item key="searchCustom">自定义搜索栏</a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import moment from 'moment'
export default {
  name: 'searchform',
  props: {
    PageName: {
      type: String,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      size: 'small',
      formList: [],
      formDatas: [],
      isExtend: true,
    }
  },
  methods: {
    initData() {
      this.form = this.$form.createForm(this)
    },
    handleSubmit() {
      this.formDatas = []
      this.getFormData(() => {
        console.log('handleSubmit', this.formDatas)
        this.$emit('backQueryParam', this.formDatas)
      })
    },
    // 获取form数据
    getFormData(func) {
      this.form.validateFields((error, values) => {
        if (!error) {
          let tmp = this.formList.filter(element => {
            return element.valueList
          })
          tmp.forEach(element => {
            if (values[element.key] && values[element.key].length === 2) {
              values[element.valueList[0]] = values[element.key][0].valueOf()
              values[element.valueList[1]] = values[element.key][1].valueOf()
            }
            delete values[element.key]
          })
          let tmpTime = this.formList.filter(element => {
            return element.isTime
          })
          tmpTime.forEach(element => {
            if (values[element.key]) {
              values[element.key] = this.$utilMoment(values[element.key]).format('YYYY-MM-DD')
            }
          })

          // 将空值设置为undefined
          Object.keys(values).map(e => {
            if (values[e] === '') {
              values[e] = undefined
            }
          })
          this.formDatas = values
          func && func(values)
        }
      })
    },
    handleReset() {
      console.log('handleReset')
      this.form.resetFields()
    },
    handleSetExtendToggle() {
      this.isExtend = !this.isExtend
    },
    handleSelectChange($event, valueName) {
      console.log('handleSelectChange', $event, valueName)
      this.form.setFieldsValue({
        [valueName]: $event,
      })
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    // 搜索栏鼠标右键菜单点击事件
    rightMenuClick({ key }) {
      switch (key) {
        case 'searchCustom':
          // this.searchFormSet()
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.search-form-container {
  background: #ffffff;
  box-shadow: 2px 0 3px rgba(0, 21, 41, 0.35);
  margin: 10px;
  margin-top: 0px;
  padding: 5px;
  .search-form-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 0px 10px;
    .form-item-wrapper {
      display: flex;
      margin: 5px;
      /deep/ .ant-form-item-control-wrapper {
        width: 230px;
      }
      /deep/ .ant-form-item-label {
        width: 100px;
      }
    }
    .button-list-wrapper {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .btn-warapper {
        margin-left: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/CustomSearchForm.vue